export default "__VITE_PUBLIC_ASSET__1159def9__"